import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  ModalContainerStyled,
  ChevronStyled as ChevronIcon,
  ModalTitleStyled as ModalTitle,
  ButtonContainerStyled as ButtonContainer,
} from './styles/FullModalStyled';

const FullModal = ({ hide, children, title }) => {
  return ReactDOM.createPortal(
    <ModalContainerStyled>
      <div
        className="modal-wrapper"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal-header">
          <ButtonContainer>
            <button
              type="button"
              className="modal-close-button"
              data-dismiss="modal"
              onClick={hide}
            >
              <ChevronIcon />
            </button>
          </ButtonContainer>
          <ModalTitle>{title}</ModalTitle>
        </div>
        <>{children}</>
      </div>
    </ModalContainerStyled>,
    document.body
  );
};

export default FullModal;

FullModal.propTypes = {
  hide: PropTypes.bool,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

FullModal.defaultProps = {
  hide: false,
};
